import { FC, Fragment, useContext, useMemo, useRef } from 'react';

import { DataTable, Dialog, useDialog } from 'components';
import { DataTableColumn, DataTableRef } from 'components/tables/data-table';
import { useFetch } from 'hooks';

import { RedeliveryContext } from './redelivery-context';

const RedeliveryActivity: FC = () => {
  const { id } = useContext(RedeliveryContext);
  const { closeDialog, openDialog, ref } = useDialog();
  const { fetchPaginated } = useFetch(`redeliveries/${id}/activity`);

  const redeliveryActivityColumns: DataTableColumn[] = useMemo(() => {
    const defaults = { width: 80, sortable: false, filterable: false, skipQuickSearch: true };
    return [
      { ...defaults, field: 'dateTime', label: 'DATE', type: 'dateTime' },
      { ...defaults, field: 'revisionType', label: 'ACTION' },
      { ...defaults, field: 'lastUpdatedBy', label: 'USER' },
      { ...defaults, field: 'description', label: 'DESCRIPTION', skipQuickSearch: false }
    ];
  }, []);

  const dataTableRef = useRef<DataTableRef>(null);

  return (
    <Fragment>
      <button
        className="btn-outline"
        data-cy="redelivery-activity-button"
        onClick={() => {
          openDialog();
          dataTableRef.current?.forceFetch();
        }}
      >
        VIEW LOG
      </button>
      <Dialog closeDialog={closeDialog} data-cy="redelivery-activity-dialog" ref={ref} style={{ direction: 'ltr' }}>
        <div className="dialog-header">
          <h3>Activity Log</h3>
          <button className="btn-close grid-1" onClick={closeDialog}>
            <span className="material-icons icon-large">close</span>
          </button>
        </div>
        <div className="dialog-body">
          <DataTable
            ref={dataTableRef}
            tableClass="activity-log"
            fetchData={fetchPaginated}
            columns={redeliveryActivityColumns}
            initialPage={{ pageNum: 0, pageSize: 5 }}
            pageSizeOptions={[5, 25, 50]}
            initialColumns={redeliveryActivityColumns}
            hideTableControls
            customQuickSearch={input => input}
          />
        </div>
      </Dialog>
    </Fragment>
  );
};

export default RedeliveryActivity;
